import { checkItem } from "ui/files/others/FilterCheckItem";

export const filterCountries: checkItem[] = [
    {
        label: "All",
        checked: true
    },
    {
        label: "Afghanistan",
        checked: false
    },
    {
        label: "Россия",
        checked: false
    },
    {
        label: "India",
        checked: false
    },
    {
        label: "United States",
        checked: false
    },
    {
        label: "France",
        checked: false
    },
    {
        label: "Singapore",
        checked: false
    },
    {
        label: "United Kingdom",
        checked: false
    },
    {
        label: "Egypt",
        checked: false
    },
    {
        label: "Saudi Arabia",
        checked: false
    },
    {
        label: "México",
        checked: false
    },
    {
        label: "Germany",
        checked: false
    },
    {
        label: "British Indian Ocean Territory",
        checked: false
    },
    {
        label: "Pakistan",
        checked: false
    }
];

export const filterMediaType: checkItem[] = [
    {
        label: "All",
        checked: true
    },
    {
        label: "Photo",
        checked: false
    },
    {
        label: "Video",
        checked: false
    },
    {
        label: "Audio",
        checked: false
    },
    {
        label: "Link",
        checked: false
    }
];

export const areaChartData = [
    {
        name: "January",
        totalIncidents: 4000,
        noCountries: 2400,
        topIncidents: 2400,
        noUsers: 1300
    },
    {
        name: "February",
        totalIncidents: 3000,
        noCountries: 1398,
        topIncidents: 2210,
        noUsers: 1500
    },
    {
        name: "March",
        totalIncidents: 2000,
        noCountries: 9800,
        topIncidents: 2290,
        noUsers: 1000
    },
    {
        name: "April",
        totalIncidents: 2780,
        noCountries: 3908,
        topIncidents: 2000,
        noUsers: 1200
    },
    {
        name: "May",
        totalIncidents: 1890,
        noCountries: 4800,
        topIncidents: 2181,
        noUsers: 1600
    },
    {
        name: "June",
        totalIncidents: 2390,
        noCountries: 3800,
        topIncidents: 2500,
        noUsers: 1800
    },
    {
        name: "July",
        totalIncidents: 3490,
        noCountries: 4300,
        topIncidents: 2100,
        noUsers: 1700
    },
    {
        name: "August",
        totalIncidents: 0,
        noCountries: 0,
        topIncidents: 0,
        noUsers: 0
    },
    {
        name: "September",
        totalIncidents: 0,
        noCountries: 1500,
        topIncidents: 0,
        noUsers: 0
    },
    {
        name: "October",
        totalIncidents: 1500,
        noCountries: 0,
        topIncidents: 0,
        noUsers: 0
    },
    {
        name: "November",
        totalIncidents: 0,
        noCountries: 0,
        topIncidents: 0,
        noUsers: 0
    },
    {
        name: "December",
        totalIncidents: 0,
        noCountries: 0,
        topIncidents: 0,
        noUsers: 0
    }
];
